<template>
  <div class="swiper-editor">
    <el-form size="small" label-width="70px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="轮播样式">
        <el-radio-group v-model="currentItem.style.template">
          <el-radio label="template1">样式一</el-radio>
          <el-radio label="template2">样式二</el-radio>
        </el-radio-group>
      </el-form-item>
      <draggable class="draggable" v-model="currentItem.sliders">
        <el-form-item label="轮播图" v-for="(item,index) in currentItem.sliders" :key="index">
          <div class="swiper-item">
            <div class="type">
              <img :src="item.src" class="swiper-img cursor-pointer" @click="select(item.src, index)"/>
            </div>
            <div class="type link">
              <span>链接</span>
              <link-to v-model="item.link"></link-to>
            </div>
            <div class="btn-group">
              <i class="el-icon-plus gray" @click="pushItem(index)"></i>
              <i class="el-icon-delete gray" @click="deleteItem(index)"></i>
            </div>
          </div>
        </el-form-item>
      </draggable>
    </el-form>
    <upload-img ref="upload" tips-width="960" tips-height="540"></upload-img>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import linkTo from '@/components/link/link'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'swiperEditor',
  components: {
    UploadImg,
    linkTo,
    draggable
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    pushItem (index) {
      this.currentItem.sliders.splice(index + 1, 0, {
        type: 'image',
        src: 'https://resource.gezishops.com/2/images/detail/KtIdsSr7HKgF8LNV0VUDVXAf1V1xDpREokREVXkM.jpeg',
        link: {}
      })
    },
    deleteItem (index) {
      if (this.currentItem.sliders.length === 0) {
        return
      }
      this.currentItem.sliders.splice(index, 1)
    },
    select (src, index) {
      this.$refs.upload.show([src], 'swiper', 1).then(res => {
        if (res.length) {
          this.currentItem.sliders[index].src = res[0]
        }
      }).catch(_ => {})
    }
  }
}
</script>
<style lang="less" scoped>
.swiper-item {
  position: relative;
  display: flex;
  background-color: #F2F6FC;
  padding: 8px;
  .swiper-img {
    height: 50px;
    width: auto;
  }
  .link {
    height: 30px;
    align-items: center;
    display: flex;
    margin-left: 5px;
    line-height: 1.2em;
    span {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  .btn-group {
    position: absolute;
    right: 5px;
    top: 0;
    i {
      font-size: 14px;
      margin-left: 5px;
      cursor: pointer;
      &.up {
        transform: rotate(90deg)
      }
      &.down {
        transform: rotate(270deg)
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/swiperEditor.vue